import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { Button } from './UI';
import { store } from '../stores/mainStore';
import { ButtonBar } from './UI';
import { integration } from '../integration';
import {history} from '../history';
import { comm } from '../comm';
import { Sprite } from './Sprite';

const ExitPage = styled.div`
	padding-top: ${p =>  0}%;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: ${p => 100}%;
	height: 100%;
	padding-top: 0%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: 90%;
	margin: 25vw auto 0;
	@media (min-aspect-ratio: 9/15){
		margin: 0 auto;
	}
	& .button-bar {
		margin-top: 2vw;
	}
`

const Message = styled(Sprite)`
	width: 90vw;
	margin: 0 auto;
	@media (min-aspect-ratio: 9/15){
		width: 80vw;
	}
`

export class ModalResign extends Component {

	cancel(){
		// window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`resign_cancel`);
		store.modal = '';
	}

	exit = () => {
		// window.manager.playAudio("poopPop");
		integration.postAnalyticsEvent(`resign_game`);
		if (!this.pending) {
			this.pending = true;
			comm.AbandonMatch(store.matchIdToResign)
			.then(() => {
				store.modal = '';
				history.push(`/`);
				store.getLobbyData(true);
			})
			.catch(() => {
				this.pending = false;
			});
		}
	}

	render() {

		return (
			<ExitPage>
				<Content>
					<CloseBox>
						<Message localize sprite="resign_message.png" />
						<ButtonBar>
							<Button cancel onClick={this.cancel}/>
							<Button resign onClick={this.exit}/>
						</ButtonBar>
					</CloseBox>
				</Content>
			</ExitPage>
		);
	}
}
